import { getCookie } from './cookies'

export function getCsrfParam(): string {
  return 'authenticity_token'
}

export function getCsrfToken(): string | undefined {
  return getCookie('CSRF-TOKEN')
}

// inertia_rails sets this cookie automatically on every Inertia response (and
// its client-side visits read it the same way), so Inertia pages can rely on
// it instead of a csrf_meta_tags meta tag.
export function getInertiaCsrfToken(): string | undefined {
  if (typeof document === 'undefined') return undefined
  return getCookie('XSRF-TOKEN')
}
